import React from 'react';
import ServicesIcon from 'resources/svg/icon-services.svg';

export const sections = [
  {
    sectionId: 'CONNECT_TOOLS',
    titleId: 'QUICK_START_CONNECT_TOOLS_TITLE',
    descriptionId: 'QUICK_START_CONNECT_TOOLS_DECSRIPTION',
    icon: 'icon-hollow-workflows',
    callToActionId: 'QUICK_START_CONNECT_TOOLS_CTA',
    callToActionRoute: () => 'IntegrationManagerPlace:/',
    helpKey: 'IntegrationManagerPlace',
  },
  {
    sectionId: 'MANAGE_SERVICE',
    titleId: 'QUICK_START_MANAGE_SERVICES_TITLE',
    descriptionId: 'QUICK_START_MANAGE_SERVICES_DECSRIPTION',
    icon: <ServicesIcon />,
    callToActionId: 'QUICK_START_MANAGE_SERVICES_CTA',
    callToActionRoute: () => 'services',
    helpKey: 'Services',
  },
  {
    sectionId: 'ADD_TEAM',
    titleId: 'QUICK_START_ORGANIZE_TEAMS_TITLE',
    descriptionId: 'QUICK_START_ORGANIZE_TEAMS_DECSRIPTION',
    icon: 'icon-hollow-people',
    callToActionId: 'QUICK_START_ORGANIZE_TEAMS_CTA',
    callToActionRoute: () => 'groups',
    helpKey: 'GroupsPlace',
  },
  {
    sectionId: 'GET_MOBILE_APP',
    titleId: 'QUICK_START_STAY_CONNECTED_TITLE',
    descriptionId: 'QUICK_START_STAY_CONNECTED_DECSRIPTION',
    icon: 'icon-mobile',
    callToActionId: 'QUICK_START_STAY_CONNECTED_CTA',
    callToActionRoute: (isReactUserProfileEnabled, loggedInUser) =>
      isReactUserProfileEnabled
        ? `UserProfile/${loggedInUser?.loggedInUserProfile?.id}/devices`
        : `UserDevicesPlace:userId=${loggedInUser?.encryptedUserId}`, // This card's button will open a dialog box after sending user to their `Devices` page
    isDeviceAction: true,
    helpKey: 'UserDevicesPlace',
  },
  {
    sectionId: 'SEND_MESSAGE',
    titleId: 'QUICK_START_SEND_MESSAGES_TITLE',
    descriptionId: 'QUICK_START_SEND_MESSAGES_DECSRIPTION',
    icon: 'icon-hollow-megaphone',
    callToActionId: 'QUICK_START_SEND_MESSAGES_CTA',
    callToActionRoute: () => 'MessagingList/',
    helpKey: 'MessagingList',
  },
  {
    sectionId: 'INITIATE_INCIDENTS',
    titleId: 'QUICK_START_INITIATE_INSTANCES_TITLE',
    descriptionId: 'QUICK_START_INITIATE_INSTANCES_DECSRIPTION',
    icon: 'icon-incidents',
    callToActionId: 'QUICK_START_INITIATE_INSTANCES_CTA',
    callToActionRoute: () => 'incidents',
    helpKey: 'IncidentsPlace',
  },
];
